import '../../../../../../../../../node_modules/vanilla-cookieconsent/dist/cookieconsent.css';
import CookieConsent from '../../../../../../../../../node_modules/vanilla-cookieconsent/dist/cookieconsent.umd.js';

export default class CookieConsentWordpress {
  constructor() {
    CookieConsent.run({
      guiOptions: {
        consentModal: {
          layout: 'box',
          position: 'bottom left',
          equalWeightButtons: true,
          flipButtons: false,
        },
        preferencesModal: {
          layout: 'box',
          position: 'left',
          equalWeightButtons: true,
          flipButtons: false,
        },
      },
      categories: {
        necessary: {
          readOnly: true,
        },
        functionality: {
          autoClear: {
            cookies: [
              {
                name: /^(pll_)/,
              },
            ],
          },
        },
        analytics: {
          autoClear: {
            cookies: [
              {
                name: /^(_ga)/,
              },
              {
                name: '_gid',
              },
            ],
          },
        },
      },
      language: {
        default: 'nl',
        autoDetect: 'document',
        translations: {
          nl: {
            consentModal: {
              title: 'We hechten belang aan uw privacy',
              description:
                'Deze website maakt gebruik van cookies om ervoor te zorgen dat u de beste ervaring op onze website krijgt.',
              acceptAllBtn: 'Alles accepteren',
              acceptNecessaryBtn: 'Alles weigeren',
              showPreferencesBtn: 'Voorkeuren aanpassen',
              footer: '<a href="/privacy-policy">Privacy Policy</a>',
            },
            preferencesModal: {
              title: 'Centrum voor toestemmingsvoorkeuren',
              acceptAllBtn: 'Alles accepteren',
              acceptNecessaryBtn: 'Alles weigeren',
              savePreferencesBtn: 'Voorkeuren opslaan',
              closeIconLabel: 'Sluit venster',
              serviceCounterLabel: 'Dienst|Diensten',
              sections: [
                {
                  title: 'Cookie gebruik',
                  description:
                    'Deze website maakt gebruik van cookies om ervoor te zorgen dat u de beste ervaring op onze website krijgt.',
                },
                {
                  title:
                    'Standaardactiviteiten <span class="pm__badge">Altijd aanvaard</span>',
                  description:
                    'Dit type van delen is nodig voor ons om toegang te hebben tot de benodigde gegevens om de website veilig te houden en ervoor te zorgen dat deze juist functioneert. <br> Verzamelde Data: <ul><li>Anonieme gegevens zoals de naam en versie van de browser</li><li>Pseudonieme gegevens zoals een authenticatietoken</li></ul>',
                  linkedCategory: 'necessary',
                },
                {
                  title: 'Personalisering van inhoud',
                  description:
                    'Indien ingeschakeld maakt u het ons mogelijk om uw voorkeuren op te slaan en een profiel over u aan te maken zodat we u gepersonaliseerde inhoud kunnen aanbieden. <br>Verzamelde Data:<ul><li>Anonieme gegevens zoals type en model apparaat en besturingssysteem</li><li>Pseudonieme gegevens zoals surfvoorkeuren op de site<li><li> Persoonlijke gegevens zoals uw IP-adres en locatie</li></ul>',
                  linkedCategory: 'functionality',
                },
                {
                  title: 'Optimalisatie van de site',
                  description:
                    'Indien ingeschakeld stelt dit ons in staat om uw gedrag te volgen zodat we de diensten op onze website voor alle bezoekers kunnen analyseren en verbeteren.<br>Verzamelde Data:<ul><li>Anonieme gegevens zoals het adres van de website die u ervoor hebt bezocht (HTTP referer)</li> <li>Pseudonieme gegevens zoals identificatoren voor activiteiten op de website</li><li>Persoonlijke gegevens zoals inhoud, zoekgeschiedenis en aankoopgeschiedenis</li>',
                  linkedCategory: 'analytics',
                },
                {
                  title: 'Meer informatie',
                  description:
                    'Voor verdere vragen over ons cookiebeleid en uw keuzes, kan u <a class="cc__link" href="/contact">contact</a> opnemen.',
                },
              ],
            },
          },
          fr: {
            consentModal: {
              title: "Nous accordons de l'importance à votre vie privée",
              description:
                'Ce site utilise des cookies pour vous garantir la meilleure expérience sur notre site.',
              acceptAllBtn: 'Accepter tout',
              acceptNecessaryBtn: 'Rejeter tout',
              showPreferencesBtn: 'Adapter les préférences',
              footer:
                '<a href="/fr/politique-de-vie-privee">Privacy Policy</a>',
            },
            preferencesModal: {
              title: 'Centre pour le consentement des préférences',
              acceptAllBtn: 'Accepter tout',
              acceptNecessaryBtn: 'Rejeter tout',
              savePreferencesBtn: 'Enregistrer les préférences',
              closeIconLabel: 'Fermer la fenêtre',
              serviceCounterLabel: 'Services|Services',
              sections: [
                {
                  title: 'Utilisation des cookies',
                  description:
                    'Ce site utilise des cookies pour vous garantir la meilleure expérience sur notre site.',
                },
                {
                  title:
                    'Opérations de base <span class="pm__badge">Toujours acceptée</span>',
                  description:
                    "Il nous faut ce type de partage pour accéder aux données garantissant le fonctionnement sûr du site. <br> Données Utilisées: <ul><li>Données anonymes : version, nom de navigateur, etc.</li><li>Données de pseudonyme : jeton d'accès, etc.</li></ul>",
                  linkedCategory: 'necessary',
                },
                {
                  title: 'Contenu personnalisé',
                  description:
                    "Cette option nous permet de sauvegarder vos choix et de créer un profil sur vous afin d'offrir du contenu personnalisé. <br>Données Utilisées:<ul><li>Données anonymes : modèle, type d'appareil, système d'exploitation, etc.</li><li>Données de pseudonyme : choix de navigation, etc.<li><li>Données personnelles : lieu, adresse IP, etc.</li></ul>",
                  linkedCategory: 'functionality',
                },
                {
                  title: 'Site optimisé',
                  description:
                    "Cette option nous permet de suivre vos actions afin d'analyser et d'améliorer les services du site web pour tous les visiteurs.<br>Données Utilisées:<ul><li>Données anonymes : adresse du dernier site web visité (référence HTTP), etc.</li> <li>Données de pseudonyme : identifiants d'activité, etc.</li><li>Données personnelles : contenu, recherche, achats, etc.</li>",
                  linkedCategory: 'analytics',
                },
                {
                  title: "Plus d'informations",
                  description: `Pour toute question concernant notre politique en matière de cookies et les choix qui s'offrent à vous, veuillez <a class="cc__link" href="/fr/contact">contacter</a>.`,
                },
              ],
            },
          },
        },
      },
    });
  }
}
